import { useTranslation } from 'react-i18next'

import { ClientScenario } from '@cash-web/protos/squareup/franklin/api/client_scenario.pb'
import { useJourneyContext } from '@cash-web/shared-journey-data-access-context'

import { HelpModalItem } from '../ui/HelpModal/HelpModalComponent'

export function useResetPasscode() {
  const { t } = useTranslation()
  const journey = useJourneyContext()

  const resetPasscodeHelpItem: HelpModalItem = {
    text: t('Forgot Cash PIN', {
      context: 'Help text. PIN (Personal Identitification Number) is a numeric 4 digit code.',
    }),
    async customAction() {
      journey.navigate(`/dl/scenario/${ClientScenario.RESET_PASSCODE}`, { replace: false })
      return { success: true }
    },
  }

  return { resetPasscodeHelpItem }
}
